import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String };
  static targets = ['chartcanvas'];

  _buildChart() {
    const chartData = JSON.parse(this.inputsValue);
    const chartOptions = {
      scales: {
        x: {
          display: false,
        },
        y: {
          display: false,
        },
      },
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'line',
      data: chartData,
      options: chartOptions,
    });
  }
}
